module.exports = __webpack_public_path__ + "static/LightVile_Logo_Gold-7635bfb20a4136ea06119e3c305cc539.png";